import { useNavigate } from "react-router-dom";
import { SlArrowDown } from "react-icons/sl";

import "./Home.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import image1 from "../../assets/me.jpeg";
function Home() {
  const navigate = useNavigate();

  return (
    <div>
      <Header />
      <div className="home_body">
        <section className="home_section_one">
          <div className="home_section_one_img_container">
            <img src={image1} alt="" />
          </div>
          <div className="home_section_one_hero">
            <h1>Harry Azamosa</h1>
            <br />
            <p>
              My name is Harry, and I am a beautiful mosaic of lived experience
              and culture.
            </p>
            <br />
            <p>
              Currently focused on numerical simulation of physical systems,
              including radiation transport, multiphase flow, thermo-fluid
              dynamics and scientific computing
            </p>
            <br />
            <p>
              Asides from Science, I spend my time building softwares and
              writing codes. I also build creative designs and art whenever I
              can. I find art a beautiful solace for the soul.
            </p>
            <br />
            <p>
              Science thrives on collaboration and critical discussion. If
              you're curious to learn more about my work, open to engaging with
              my mission, or interested in building a shared vision, I would
              love to hear from you. Please get in touch.
            </p>
            <br />
            <p>
              <b>Email:</b>{" "}
              <span
                onClick={() =>
                  (window.location =
                    "mailto:johnharry@gmail.com?subject=Access request")
                }
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  color: "blue",
                }}
              >
                Johnharry238@gmail.com
              </span>
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Home;
